import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Agenda from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.agenda,
    speedDatingMeetings: state.speedDating.meetings,
  };
}

function mapDispatchToProps() {
  return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Agenda));



// WEBPACK FOOTER //
// ./src/components/Agenda/container/index.js